

























































































import Vue from "vue";
import { Header } from "../../MyTable.vue";
import CreateGrayscale from "./CreateGrayscale.vue";
import CreateGrayscaleForm from "./CreateGrayscaleForm.vue";
import CreateGrayscaleFormExt from "./CreateGrayscaleFormExternal.vue";
import GrayInfo from "./GrayInfo.vue";
import { axios } from "../../../plugins";
import { uuid } from "@/utils/uuid";

const TableHeader: Header[] = [
  { title: "名称", minWidth: 300 },
  // { title: "应用", width: 200 },
  { title: "发布类型", width: 200 },
  { title: "灰度组件", width: 200 },
  { title: "版本对比", width: 200 },
  { title: "状态", width: 200 }
  // { title: "TCP-入站流量", width: 200 }
];
export default Vue.extend({
  name: "Grayscale",
  components: {
    CreateGrayscale,
    CreateGrayscaleForm,
    GrayInfo,
    CreateGrayscaleFormExt
  },
  props: {
    data: { type: Object },
    type: { type: String },
    projectId: { type: String }
  },
  inheritAttrs: false,
  data() {
    return {
      loadType: "",
      TableHeader,
      tableData: [],
      loading: false,
      service: "",
      serviceOptions: [] as string[]
    };
  },
  mounted() {
    this.getService();
    // this.getTable();
  },
  methods: {
    getService() {
      axios
        .get(`/service/${this.projectId}?page=1&listId=${uuid()}&size=9999`)
        .then(res => {
          this.serviceOptions = res.data.data.list;
          this.service = (this.serviceOptions[0] as any).metadata.name;
          this.getTable();
        });
    },
    getTable() {
      this.loading = true;
      axios
        .get(
          `/grayrelease/${this.projectId}/release?serviceName=${this.service}`
        )
        .then(res => {
          this.tableData = res.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refush() {
      this.getTable();
    },
    info(data: any) {
      if (data.status) {
        (this.$refs.grayInfo as any).show(data);
      }
    },
    create() {
      (this.$refs.create as any).show();
    },
    createGrayscale(data: any) {
      if (data.external) {
        (this.$refs.createFormEx as any).show(data.grayscale);
      } else {
        (this.$refs.createForm as any).show(data.grayscale);
      }
    }
  }
});
